// extracted by mini-css-extract-plugin
export default {"Dialog":"CheckStatusDialog-module__Dialog--k1EnR","Dialog_Body":"CheckStatusDialog-module__Dialog_Body--sRD_i","Box":"CheckStatusDialog-module__Box--uYuTX"};